import { styled } from "styled-components";
const ToastImplWrapper = styled("div").attrs(({ $clickable }) => ({
  role: $clickable ? "button" : void 0
}))(
  ({ theme }) => ({
    alignItems: "center",
    backgroundColor: "white",
    borderRadius: 4,
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
    color: theme.color.default,
    display: "flex",
    fontFamily: theme.fontFamily.default,
    fontSize: theme.fontSize.default,
    left: "50%",
    padding: "0 16px",
    position: "fixed",
    transform: "translateX(-50%)",
    whiteSpace: "nowrap",
    width: "fit-content"
  }),
  ({ $clickable }) => ({ cursor: $clickable ? "pointer" : "default" }),
  ({ $appearance, theme }) => ({
    danger: {
      backgroundColor: theme.color.red6,
      color: "rgba(255, 255, 255, 0.85)"
    },
    dark: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      color: "rgba(255, 255, 255, 0.85)"
    }
  })[$appearance]
);
const ToastImplInner = styled("div")({
  overflow: "hidden"
});
export {
  ToastImplInner,
  ToastImplWrapper
};
